import { handleSystemErrorReport } from '@mb/lib/utils';
import axios from 'axios';

//  Get materials Stock data
export const checkMultipleMaterialsAvailability = async (
  materialsIds: string[],
) => {
  try {
    if (materialsIds?.length === 0) {
      return null;
    }

    const bodyFormData = new FormData();
    bodyFormData.append('items', materialsIds?.join(','));
    bodyFormData.append('origin', 'search');

    const response = await axios.post(
      '/catalog/product/inventory',
      bodyFormData,
    );
    const { data } = response;
    return data?.data;
  } catch (error) {
    console.error('Error while checking stock >>> ', error.message);
    handleSystemErrorReport(
      `Error checkMultipleMaterialsAvailability: ${error.message}`,
      'check stock',
    );
    return null;
  }
};
